export default function mergeStyle(style, objectStyle) {
    let styleObject;
    if (typeof style === "string") {
        styleObject = {};
        style.split(";").forEach((item) => {
            const [key, value] = item.split(":");
            if (key && value) {
                styleObject[key.trim()] = value.trim();
            }
        });
    }
    else if (typeof style === "object" && style) {
        styleObject = style;
    }
    else {
        styleObject = {};
    }
    return { ...styleObject, ...objectStyle };
}
